module.exports = __webpack_public_path__ + "static/media/photo-selfie.b0f0e603.png";